import { createSlice } from '@reduxjs/toolkit';
import { REDUCER_BASE_NAME } from '#base/constants';
import { StateBaseType } from '#base/types';

const initialState: StateBaseType = {};

const sliceBase = createSlice({
  name: REDUCER_BASE_NAME,
  initialState,
  reducers: {},
});

const reducerBase = sliceBase.reducer;

export {
  reducerBase,
};
